import type { HelpFile } from '../../types/help'
import { AutoAssignRuleRequestEditTestIds } from '../../../testids/AutoAssignRuleRequestEditTestIds'

export const autoAssignRuleRequestEditHelp: HelpFile = {
  docPage: '/docs/governance/auto-assign-rules',
  texts: {
    [AutoAssignRuleRequestEditTestIds.autoAssignRuleRequestEditPage]: 'Einen Entwurf eines Antrags zur Änderung einer Auto-Zuweisungsregel bearbeiten — Ausdruck, Zugriffsprofile und Genehmiger vor dem Einreichen anpassen.',
    [AutoAssignRuleRequestEditTestIds.btnBackNotEditable]: 'Zur Antragsdetailansicht zurückkehren. Der Antrag kann im aktuellen Status nicht mehr bearbeitet werden.',
  },
}
